/*
  Livraison offerte : bandeau du haut de page + encart du panier (v6.1, 08/10/2026).

  - Seuils lus dans les réglages du thème (« Livraison offerte ») via les attributs data-* posés par Liquid.
  - Prix actuels demandés à Shopify (tarifs réels du checkout, adresse type Paris 75001 : la grille ne dépend
    que du montant). Mis en cache en sessionStorage par contenu de panier.
  - Seuls comptent les cafés du profil d'expédition général : on écarte les abonnements et cadeaux (adresse
    produit en « abonnement- » ou abonnement rattaché) et ce qui ne s'expédie pas (cartes cadeaux).
  - Rafraîchi à chaque changement de panier (événement Dawn « cart-update » et « cart:updated » des cartes
    café et du chat).
  - Textes dans la langue de la page : window.scFreeShippingStrings, posé par snippets/free-shipping-strings.liquid
    (clés singular.shipping des locales) ; le repère [amount] est complété ici.
*/
(function () {
  if (window.scFreeShippingLoaded) return;
  window.scFreeShippingLoaded = true;

  var RATES_QS = 'shipping_address%5Bzip%5D=75001&shipping_address%5Bcountry%5D=France';
  var CACHE_KEY = 'sc-free-shipping-rates';
  var S = window.scFreeShippingStrings || {};

  function fill(template, amount) {
    return String(template).split('[amount]').join(amount);
  }

  function euros(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return s + ' €';
  }

  function isCoffeeLine(item) {
    if (!item.requires_shipping) return false;
    if (item.selling_plan_allocation) return false;
    if ((item.handle || '').indexOf('abonnement-') === 0) return false;
    return true;
  }

  function readCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function summarize(cart) {
    var coffee = 0, coffeeCount = 0, other = 0;
    (cart.items || []).forEach(function (item) {
      if (isCoffeeLine(item)) {
        coffee += item.final_line_price;
        coffeeCount += item.quantity;
      } else if (item.requires_shipping) {
        other += 1;
      }
    });
    // Le seuil Shopify s'applique APRÈS réduction (vérifié le 08/10 avec BIENVENUE10) : on retire la part des
    // réductions de commande déjà posées sur le panier. Un code saisi seulement au paiement reste invisible ici.
    var cartDiscount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) { cartDiscount += d.total_allocated_amount || 0; });
    if (cartDiscount > 0 && cart.items_subtotal_price > 0) {
      coffee -= Math.round(cartDiscount * (coffee / cart.items_subtotal_price));
    }
    return { coffee: coffee, coffeeCount: coffeeCount, hasOther: other > 0, key: cart.token + ':' + cart.total_price + ':' + cart.item_count };
  }

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // Tarifs réels : prepare puis lecture asynchrone (202 tant que Shopify calcule).
  function fetchRates(key) {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.key === key) return Promise.resolve(cached.rates);
    } catch (e) {}
    return fetch('/cart/prepare_shipping_rates.json?' + RATES_QS, { method: 'POST' })
      .then(function () {
        var tries = 0;
        function poll() {
          tries += 1;
          return sleep(300)
            .then(function () { return fetch('/cart/async_shipping_rates.json?' + RATES_QS); })
            .then(function (r) {
              if (r.status === 202 && tries < 15) return poll();
              if (!r.ok) throw new Error('rates ' + r.status);
              return r.json();
            });
        }
        return poll();
      })
      .then(function (data) {
        var rates = { relay: null, home: null };
        (data.shipping_rates || []).forEach(function (rate) {
          var name = (rate.name || '').toLowerCase();
          var cents = Math.round(parseFloat(rate.price) * 100);
          // Noms des modes dans la langue de la page : « point relais Mondial Relay » / « Pickup point delivery (Mondial Relay) »
          var relay = name.indexOf('relais') !== -1 || name.indexOf('mondial relay') !== -1;
          var home = name.indexOf('domicile') !== -1 || name.indexOf('colissimo') !== -1;
          if (relay && (rates.relay === null || cents < rates.relay)) rates.relay = cents;
          if (home && (rates.home === null || cents < rates.home)) rates.home = cents;
        });
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key: key, rates: rates })); } catch (e) {}
        return rates;
      });
  }

  function withTimeout(promise, ms) {
    return Promise.race([promise, sleep(ms).then(function () { return null; })]).catch(function () { return null; });
  }

  // --- Bandeau du haut : point relais seulement ---
  function renderBar(bar, sum, rates) {
    var threshold = parseInt(bar.dataset.relayThreshold, 10);
    var text = bar.querySelector('[data-free-shipping-text]');
    var html;
    // Les vrais tarifs Shopify font foi quand on les a ; sinon on compare au seuil.
    var trusted = rates && rates.relay !== null && !sum.hasOther;
    var free = trusted ? rates.relay === 0 : sum.coffee >= threshold;
    if (sum.coffeeCount === 0) {
      html = fill(S.freeFrom, euros(threshold));
    } else if (free) {
      html = S.free;
    } else if (threshold - sum.coffee <= 0) {
      html = trusted ? fill(S.cost, euros(rates.relay)) : S.free;
    } else {
      html = fill(S.remainingHtml, euros(threshold - sum.coffee));
      if (trusted) {
        html = fill(S.cost, euros(rates.relay)) + '. ' + html;
      }
    }
    text.innerHTML = html;
    bar.classList.add('is-ready');
  }

  // --- Encart du panier : point relais et domicile ---
  function trackHtml(label, now, coffee, threshold) {
    var done = now === null || now === undefined ? coffee >= threshold : now === 0;
    var pct = Math.min(100, Math.round((coffee / threshold) * 100));
    var price = now === 0 || done ? '<strong>' + S.offered + '</strong>' : now === null ? '' : euros(now);
    var html = '<div class="free-shipping-progress__row"><div class="free-shipping-progress__top"><strong>' + label + '</strong><span>' + price + '</span></div>';
    if (!done && threshold - coffee > 0) {
      html +=
        '<div class="free-shipping-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="' + label + '">' +
        '<div class="free-shipping-progress__fill" style="width:' + pct + '%"></div></div>' +
        '<div class="free-shipping-progress__sub">' + fill(S.remaining, euros(threshold - coffee)) + '</div>';
    }
    return html + '</div>';
  }

  function renderBox(box, sum, rates) {
    if (sum.coffeeCount === 0) {
      box.hidden = true;
      return;
    }
    var relayThreshold = parseInt(box.dataset.relayThreshold, 10);
    var homeThreshold = parseInt(box.dataset.homeThreshold, 10);
    var showPrices = rates && !sum.hasOther;
    box.innerHTML =
      trackHtml(S.pickup, showPrices ? rates.relay : null, sum.coffee, relayThreshold) +
      trackHtml(S.home, showPrices ? rates.home : null, sum.coffee, homeThreshold);
    box.hidden = false;
  }

  var running = null;
  function refresh() {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    var boxes = document.querySelectorAll('[data-free-shipping-progress]');
    if (!bars.length && !boxes.length) return;
    var run = (running = readCart().then(function (cart) {
      var sum = summarize(cart);
      if (run !== running) return;
      var needRates = sum.coffeeCount > 0;
      var ratesPromise = needRates ? withTimeout(fetchRates(sum.key), 4000) : Promise.resolve(null);
      return ratesPromise.then(function (rates) {
        if (run !== running) return;
        bars.forEach(function (bar) { renderBar(bar, sum, rates); });
        boxes.forEach(function (box) { renderBox(box, sum, rates); });
      });
    }).catch(function () {
      bars.forEach(function (bar) { bar.classList.add('is-ready'); });
    }));
  }

  var timer;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }

  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
    refresh();
  });
})();
